<template>
    <div
        class="no-expand-validator"
        v-on:click.stop="">
        <template v-if="componentValidator != null">
            <component
                v-bind="binder"
                v-bind:is="component"
                v-on:update:model-value="$emit('update:modelValue', $event)" />
        </template>
    </div>
</template>

<script>
    import { getValidator, VALIDATOR_TYPES } from "Validation/validator.js";
    import { DATA_FIELD_TYPE, DATA_FIELD_ENCODING_TYPE } from "Types/dataFieldTypes.js";
    import { THOUSAND_SEPARATOR_FORMATTER, INTEGER_FORMATTER, getDataFormatter } from "Util/dataFormatters";

    export default {
        props: {
            datafield: { type: Object, required: true },
            modelValue: { type: String, required: true },
            readonly: { type: Boolean, required: true },
            isRequired: { type: Boolean, required: true }
        },
        emits: ["update:modelValue"],
        computed: {
            component() {
                if (this.datafield.TypeId === DATA_FIELD_TYPE.DateTime) {
                    return "pc-date";
                }
                return "pc-input";
            },
            componentValidator() {
                const validators = [];
                const attributes = {};
                switch (this.datafield.TypeId) {
                    case DATA_FIELD_TYPE.Integer:
                        validators.push(VALIDATOR_TYPES.integer);
                        attributes["inputmode"] = "numeric";
                        break;
                    case DATA_FIELD_TYPE.Decimal:
                        if (this.datafield.EncodingTypeId != DATA_FIELD_ENCODING_TYPE.Price) {
                            validators.push(VALIDATOR_TYPES.decimal);
                            attributes["inputmode"] = "decimal";
                        }
                        break;
                    case DATA_FIELD_TYPE.DateTime:
                        validators.push(VALIDATOR_TYPES.date);
                        break;
                    case DATA_FIELD_TYPE.String:
                        break;
                }

                switch (this.datafield.EncodingTypeId) {
                    case DATA_FIELD_ENCODING_TYPE.Price:
                        attributes["prependItems"] = ["$"];
                        validators.push(VALIDATOR_TYPES.money);
                        break;
                    case DATA_FIELD_ENCODING_TYPE.Email:
                        validators.push(VALIDATOR_TYPES.email);
                        attributes["inputmode"] = "email";
                        break;
                }

                if (this.isRequired) {
                    validators.push(VALIDATOR_TYPES.required);
                }
                return { validator: getValidator(this.$app, validators), attributes };
            },
            dataFormatter() {
                if (!this.datafield) {
                    return null;
                }
                const formatters = [];
                if (this.datafield.TypeId === DATA_FIELD_TYPE.Integer) {
                    formatters.push(INTEGER_FORMATTER);
                }
                if (this.datafield.ShowSeparators) {
                    formatters.push(THOUSAND_SEPARATOR_FORMATTER);
                }
                if (formatters.length > 0) {
                    return getDataFormatter(formatters);
                }
                return null;
            },
            binder() {
                return {
                    dataFormatter: this.dataFormatter,
                    modelValue: this.modelValue,
                    readonly: this.readonly,
                    validator: this.componentValidator.validator,
                    ...this.componentValidator.attributes,
                    altLabel: this.datafield.Name,
                    name: "tableItemComponent"
                };
            }
        }
    };
</script>

<style lang="scss" scoped>
    // Don't expand any child validators
    .no-expand-validator :deep(.invalid-feedback) {
        width: 0;
        min-width: 100%;
    }
</style>
